<template>
  <!-- index 首页 new 内容区 -->
  <div class="page">
    <!-- 区域一  -->
    <div class="box1">
      <div class="boxW box1In ">

        <!-- 信用动态 -->
        <!-- <div class="flex box1Top">
          <div class="flex tit">
            <div class="icon">
              <img src="/static/images/new/xydt.png" />
            </div>
            <div class="titImg">
              <img src="/static/images/new/xydtTit.png" />
            </div>
          </div>
          <div class="flex content">
            <div> <span>【地方】 </span>倒逼激励并用推进环保信用分级分类监…</div>
            <div> <span>【地方】 </span>倒逼激励并用推进环保信用分级分类监…</div>
          </div>
          <div class="more"><a href="">查看全部 ></a> </div>
        </div> -->
        <!-- 企业信用课堂 -->
        <ul class="grid box1Bot">
          <li class="flex Box1Img" v-for="(item,index) in list" :key="index" @click="goLxList(item)" style="cursor:pointer">
            <div class="imgBox1">
              <img :src="item.urlPic" />
            </div>
            <div class="text">
              <h3>{{item.headline}}</h3>
              <p>{{item.explains}}</p>
            </div>

            <!-- <div class="tag">免费</div> -->
          </li>

        </ul>
      </div>
    </div>
    <!--区域二  课程推荐-->
    <div class=" box2">
      <div class="boxW box2In">
        <div class="tit">
          <div class="icon">
            <img src="/static/images/new/kctj.png" />
          </div>
          <!-- <div class="txt">课程推荐</div> -->
        </div>
        <ul class=" content">

          <li v-for="(item,index) in kcData" :key="index" @click="getDetail(item)" style="cursor:pointer">
            <div class="tag">共{{item.kcCount}}节</div>
						<div class="tag_img" v-show="item.lxName == '企业信用课程'">
							<img src="/static/images/tj.png" alt="">
						</div>
            <div class="imgBox">
              <img :src="item.lxIcon" />
            </div>
            <div class="txtContent">
              <div class="flex dataNum">
                <span> <span v-if="item.money!=0">¥</span> {{item.money==0?"免费":item.money}} <span style="font-size: 16px;" v-show="item.lxName == '企业信用课程' && item.money">起</span></span> <span>{{item.learnCount}}人已学</span>
              </div>
              <h3>{{item.lxName}}</h3>
              <p>{{item.lxSubName}}</p>
            </div>
          </li>

        </ul>
      </div>

    </div>
    <!-- 区域三  -->
    <div class="box3">

      <!-- 信用服务 -->
      <div class="cont1">
        <div class="boxW cont1In">
          <div class="tit">
            <div class="icon">
              <img src="/static/images/new/xyfwTit.png" />
            </div>
            <!-- <h3>信用服务</h3> -->
          </div>
          <div class="content">
            <div class="flex top">
              <div class="txt">服务平均分</div>
              <div class="rate">
                <!-- score-template="{rateValue}" -->
                <img src="/static/images/new/rate.png" />
                <!-- <el-rate v-model="rateValue" disabled  text-color="#ff9900" >
                </el-rate> -->
              </div>
            </div>
            <ul class="flex bot">
              <li v-for=" (item,index) in xyfwData">
                <div class="num">{{item.num}}</div>
                <div class="txt">{{item.tit}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 服务评价 -->
      <div class="cont2">
        <div class="boxW cont1In">
          <div class="tit">
            <div class="icon">
              <img src="/static/images/new/fwpjTit.png" />
            </div>
          </div>
          <div class="content">
            <div class="flex top">
              <!-- 三个小球 -->
              <div></div>
              <div></div>
              <div></div>
            </div>
            <ul class="con">
              <li class="flex " v-for="(item,index) in newsData">
                <div class="flImg">
                  <!-- <img :src="item.headerImg" /> -->
                  <img src="/static/images/user.png" />
                </div>
                <div class="frNews">
                  <div class="news">{{item.content}}</div>
                  <div class="flex info">
                    <div class="companyName">{{item.qyName}}</div>
                    <div class="rate">
                      <img src="/static/images/new/rateSmall.png" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div class="cont3">
        <div class="boxW cont3In">
          <div class="tit">
            <div class="icon">
              <img src="/static/images/new/hzhbTit.png" />
            </div>
            <!-- <h3>合作伙伴</h3> -->
          </div>
          <!-- 公司名称  -->
          <ul class="flex partner">
            <li v-for="(item,index) in partnerList">
              <img :src="item.imgUrl" />
            </li>
          </ul>
        </div>

      </div>
    </div>
    <!-- 绑定企业的弹框 -->
    <el-dialog title="选择培训的企业" :visible.sync="dialogVisible" width="480px" :before-close="hangleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" @submit.native.prevent class="demo-ruleForm">
        <p style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;" v-if="flag == 2">您好，请先选择您要培训的类型</p>
        <p style="font-size: 16px; padding-left: 20px;padding-bottom: 50px;" v-else>
          您好，请先关联您要进行培训的
          <span style="color: red;">浙江省</span>企业：
        </p>
        <el-form-item label="企业名称" prop="priseName" v-if="flag != 2">
          <el-input v-model="ruleForm.priseName" style="width: 240px;" placeholder="请输入相关企业" :maxlength="25" clearable></el-input>
        </el-form-item>

        <el-form-item label="选择类型" prop="lxId" v-if="flag != 0">
          <el-select :popper-append-to-body="false" v-model="ruleForm.lxId" placeholder="请选择类型" filterable clearable
            style="width: 240px;" @change="changeLx">
            <el-option v-for="item in listData" :label="item.lxName" :value="item.lxId" :key="item.lxId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button style="width: 220px;margin: 10px;" type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </el-form-item>
        <div class="prise_center">
          <div class="prise_left" style="cursor: pointer;" v-if="flag != 2" @click="headleOpen">关联非浙江省企业></div>
          <!-- <div class="prise_left" style="cursor: pointer;" v-else @click="hangleProvinceIn">关联浙江省企业></div> -->
          <!-- <div class="prise_left">个人参加培训></div> -->
        </div>
      </el-form>
    </el-dialog>
    <!--  -->
    <smrz ref="smrz"></smrz>
  </div>
</template>

<script>
  import {
    cookie
  } from "@/common/js/cookies.js";
  import smrz from "@/components/common/shrz";
  export default {
    components: {
      smrz
    },
    data() {
      return {
        //星数
        rateValue: 5,
        lxId: null,
        qyrz: false, //企业关联状态
        dialogVisible: false,
        flag: 0, //来判断触发
        listData: [], //切换的数据类型
        countNum:null,
        ruleForm: {
          priseName: null, //企业名字
          lxId: null, //类型id
        },
        rules: {
          priseName: [{
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          }, ],
          lxId: [{
            required: true,
            message: "请选择类型",
            trigger: "change",
          }, ],
        },
        // 企业信用课堂
        list: [],
        // 信用服务
        xyfwData: [{
            num: null,
            tit: "专题培训总量"
          },
          {
            num: null,
            tit: "正在培训企业数"
          },
          {
            num: null,
            tit: "出具培训证明企业数"
          },
          {
            num: null,
            tit: "出具信用报告企业数"
          }
        ],
        // 课程推荐
        kcData: [],
        // 服务评价
        newsData: [],
        // 合作伙伴
        partnerList: [
          // {
          //   imgUrl: "/static/images/new/partner/11.png"
          // }, {
          //   imgUrl: "/static/images/new/partner/22.png"
          // }, {
          //   imgUrl: "/static/images/new/partner/33.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/44.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/55.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/66.png"
          // }, {
          //   imgUrl: "/static/images/new/partner/77.png"
          // }, {
          //   imgUrl: "/static/images/new/partner/88.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/99.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/111.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/222.png"
          // }, {
          //   imgUrl: "/static/images/new/partner/333.png"
          // }, {
          //   imgUrl: "/static/images/new/partner/444.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/555.png"
          // },
          // {
          //   imgUrl: "/static/images/new/partner/666.png"
          // }
          {
            imgUrl: "/static/images/new/partner/1.png",
            link: "https://www.creditchina.gov.cn"
          },
          {
            imgUrl: "/static/images/new/partner/2.png",
            link: "http://fzggw.zj.gov.cn/"
          },
          {
            imgUrl: "/static/images/new/partner/3.png",
            link: "http://www.zjxyxh.org/"
          },
          {
            imgUrl: "/static/images/new/partner/4.png",
            link: "http://www.zfc.edu.cn/"
          },
          {
            imgUrl: "/static/images/new/partner/5.png",
            link: ""
          }
        ]
      }
    },
    created() {
      this.getXykt();
      this.getLxList();
      this.getQyList();
      this.getStatistics();
      this.getFwpj();
      this.getDataList();
    },
    computed: {
      token() {
        return cookie.get("xyxf_token_qt");
      },
    },
    methods: {
      //筛选课程分类
      goLxList(item){
        this.$router.push({
          path: "/courseIndex",
          query: {
            headId:item.id,
          }
        });
      },
      // 清除表单
      hangleClose() {
        this.$refs["ruleForm"].resetFields();
        this.dialogVisible = false;
      },
      changeLx(val) {
        let lxList = this.listData;
        let currentLxArr = lxList.filter((item) => item.lxId == val);
        this.sfnbg = currentLxArr[0].lxCjbg;
      },
      //关联浙江企业
      hangleProvinceIn() {
        if (this.clickTarget == "btn") {
          this.flag = 1;
        } else {
          this.flag = 0;
        }
      },
      // 企业信用课堂列表获取
      getXykt() {
        this.$http.get(SOWINURL + 'zxpxLxHead/lxHeadList', {}).then(res => {
          if (res.data.result == 1) {
            this.list = res.data.data;
          }
        }).catch(err => {

        })
      },
      //课程推荐
      getLxList() {
        console.log("kais")
        this.$http({
          method: 'get',
          url: SOWINURL + "index/getLxList",
          params: {
            page: 1,
            pageSize: 8,
            headId: ''
          }
        }).then(res => {
          let data = res.data.data;
          this.kcData = data.courseTypeMoneyVos;
        }).catch(err => {

        })
      },
      // 立即学习 详情
      getDetail(item) {
        this.countNum= item.kcCount;
        this.lxId = item.lxId;
        // 是否登录
        if (!this.token) {
          console.log('未登录')
          this.$router.push('/');
          this.$message.error('请先登录');
        } else {
          if (this.qyrz == false) {
            this.dialogVisible = true;
          } else {
            this.getQyExist();

          }

        }
      },
      // 绑定企业
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.flag == 0 || this.flag == 1) {
              // this.activeOne = this.ruleForm.lxId;
              this.getEnterprise();
            } else {
              // this.dialogVisible = false;
              // let routerUrl = this.$router.resolve({
              //   path: "/qyrz",
              //   query: {
              //     lxCjbg: this.sfnbg,
              //     qyActive: 1,
              //     pxlx: this.ruleForm.lxId,
              //   },
              // });
              // window.open(routerUrl.href, "_blank");
            }

            // this.$refs.btnClick.hangleVideo(_self.btnKcid);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
	  // 跳转非浙江省企业
	  headleOpen(){
		 this.dialogVisible = false;
		 let routerUrl = this.$router.resolve({
		   path: "/qyrz",
		   query: {
		     lxCjbg: this.sfnbg,
		     qyActive: 1,
		     pxlx: this.ruleForm.lxId,
		   },
		 });
		 window.open(routerUrl.href, "_blank"); 
	  },
      // 判断进入是否有企业
      getEnterprise() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        let formdata = new FormData();
        formdata.append("enterpriseName", _self.ruleForm.priseName);
        ajax({
            method: "post",
            url: SOWINURL + "index/getEnterprise",
            data: formdata,
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 200) {
              _self.uniscid = json.data.data;
              setTimeout(() => {
                _self.getAdd();
              }, 300);
            } else if (json.data.result == 404) {
              _self.$message({
                showClose: true,
                message: json.data.data,
                type: "error",
              });
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            loading.close();
          });
      },
      // 验证企业
      getQyExist() {
        this.$http.get(SOWINURL + 'getQyExist', {
          params: {
            lxId: this.lxId,
            enterpriseId: this.enterpriseId
          }
        }).then(res => {
          if (res.data.result == 1) {
            // 真实企业id
            this.qyId = res.data.data.qyId;
            this.getVideoDetail();

          }else {
            // console.log(res.data.data)
              this.$message({
                showClose: true,
                message: res.data.data,
                type: "error",
              });
            }
        }).catch(err => {

        })

      },
      // 获取企业列表
      getQyList() {
        this.$http.get(SOWINURL + 'index/getUserQy', {}).then(res => {
          if (res.data.result == 1) {
            let data = res.data.data;
            // this.qyList = res.data.data;
            // this.qyId = data.qyId;
            this.enterpriseId = data.currEnterprise.id;
            // 企业 绑定状态
            if (data.enterpriseList.length < 1) {
              this.qyrz = false;
            } else {
              this.qyrz = true;
            }
          }
        }).catch(err => {

        })
      },
      //作用于来判断 点击下一步是什么功能
      getVideoDetail() {
        let _self = this;
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        _self.$http.post(SOWINURL + 'XxKh/getVideoDetail', {
            kcId: null,
            lxId: _self.lxId,
            qyId: _self.qyId
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 1) {


              if(!_self.countNum||_self.countNum==0){
                 _self.$message('此课程没有视频')
              }else{
                _self.$router.push({
                  path: "/courseDetail",
                  query: {
                    lxId: _self.lxId,
                    // kcId: _self.btnKcid,
                    qyId: _self.qyId,
                  },
                });
              }
            } else if (json.data.result == 400) {
              _self.isAutoProcess = false;
              // 点击视频没有关联企业开启自动流程把当前数据存起来
              let NEXT_DO_OBJ = {
                qyId: _self.qyId,
                lxId: _self.lxId,
                // kcId: _self.btnKcid,
              };
              localStorage.setItem("NEXT_DO_OBJ", JSON.stringify(NEXT_DO_OBJ));
              if (json.data.data.enterprise == 0) {
                //2，名下是否有企业
                _self.hangleRepair("open");
                // _self.$emit("hangleLength", 1, _self.activeOne);
                return;
              } else if (json.data.data.autonym == 0) {
                //1,实名
                _self.smrzClick();
                return;
              } else if (json.data.data.check == 0) {
                // 是否审核通过
                _self.$message({
                  showClose: true,
                  message: '资料正在审核中',
                  type: "error",
                });
              } else if (json.data.data.pay == 0) {
                // 3，是否支付
                _self.hangleZf();
                return;
              } else if (json.data.data.authorization == 0) {
                // 4，是否授权
                _self.$router.push({
                  path: "/yzf",
                  query: {
                    lxId: _self.lxId,
                    // kcId: _self.btnKcid,
                    qyId: _self.qyId,
                  },
                });
                return;
              } else {
                _self.$router.push({
                  path: "/courseDetail",
                  query: {
                    lxId: _self.lxId,
                    qyId: _self.qyId,
                  },
                });
              }
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            loading.close();
            console.log(error);
          });
      },
      // 企业添加
      getAdd() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        let formdata1 = new FormData();
        formdata1.append("enterpriseName", _self.ruleForm.priseName);
        // formdata1.append("lxId", _self.activeOne);
        formdata1.append("uniscid", _self.uniscid);

        ajax({
            method: "post",
            url: SOWINURL + "index/saveEnterprise",
            data: formdata1,
          })
          .then(function(json) {
            loading.close();
            if (json.data.result == 200) {
              _self.$message({
                showClose: true,
                message: "关联企业成功",
                type: "success",
              });
              _self.dialogVisible = false;
              _self.qyrz = true; //企业关联状态
              _self.enterpriseId = json.data.data.eid; // id
              _self.getQyExist();
              // _self.qyLength = 1;
              // _self.getUserQy();
              // _self.btnTrigger();
              // _self.getActive();
            } else {
              _self.$message({
                showClose: true,
                message: json.data.data,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            loading.close();
          });
      },
      // 实名认证
      smrzClick() {
        this.$refs["smrz"].sign = 1;
        this.$refs["smrz"].kcId = this.btnKcid;
        this.$refs["smrz"].drawer = true;
      },
      // 支付
      hangleZf() {
        this.$router.push({
          path: "/dzf",
          query: {
            id: this.qyId,
            lxid: this.lxId,
          },
        });
      },
      // 点击去培训来判断
      hangleRepair(type) {
        if (type == "open") {
          this.isAutoProcess = true; //开启自动流程
        }
        this.flag = 0;
        this.clickTarget = "video";
        this.ruleForm.priseName = ""; //每次点击都空
        this.ruleForm.lxId = ""; //每次点击都空
        this.dialogVisible = true;
      },
      // 信用服务接口
      getStatistics() {
        this.$http.get(SOWINURL + 'index/statistics', {

        }).then(res => {
          if (res.data.result == 1) {
            let data = res.data.data;
            this.xyfwData[0].num = data.total;
            this.xyfwData[1].num = data.processing;
            this.xyfwData[2].num = data.zmNum;
            this.xyfwData[3].num = data.bgNum;
          }
        }).catch(err => {

        })

      },

      // 类型列表提交排序
      getDataList() {
        let _self = this;
        let ajax = _self.$http.create();
        const loading = _self.$loading({
          lock: false,
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.5)",
        });
        ajax({
            method: "get",
            url: SOWINURL + "index/lxList",
            data: {},
          })
          .then(function(json) {
            // console.log(json)
            loading.close();
            if (json.data.result == 1) {
              _self.listData = json.data.data;

              _self.items = json.data.data[0].kcList

              if (_self.listData && _self.listData.length > 0) {
                if (!_self.activeOne) {
                  _self.activeOne = _self.listData[0].lxId;
                }
                if (!_self.kcId) {
                  _self.kcId = _self.listData[0].kcId;
                }
              }

              // _self.getActive();
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: "error",
              });
            }
          })
          .catch(function(error) {
            loading.close();
            console.log(error);
          });
      },
      // 获取服务评价
      getFwpj() {
        this.$http.get(SOWINURL + 'comment/commentList', {
          params: {
            pageSize: 4,
            page: 1,
            lxId: null
          }
        }).then(res => {
          if (res.data.result == 1) {
            this.newsData = res.data.data.indexPlVos;
          }
        }).catch(err => {

        })
      }

    }
  }
</script>

<style scope lang="less">
  .flex {
    display: flex;
  }

  .grid {
    display: grid;
  }

  .bg {
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .boxW {
    width: 1180px;
    margin: 0 auto;
  }

  .page {

    .tit {
      .icon {}
    }

    ////////////////////////

    .box1 {
      min-height: 257px;
      background-color: #FFFFFF;
      display: flex;
      align-items: center;

      .box1Top {
        height: 60px;
        justify-content: space-between;
        align-items: center;
        background: #F5F9FF;
        border-radius: 12px;
        padding: 0 14px;
        margin-bottom: 30px;

        .tit {
          align-items: center;


          .icon {
            // margin-right: 6px;
          }

          .titImg {
            width: 85px;
            height: 28px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .content {
          >div {
            width: 378px;
            font-size: 14px;
            font-weight: 400;
            color: #312120;
          }

          >div:last-child {
            margin-left: 64px;
          }
        }

        .more {
          a {
            font-size: 14px;
            font-weight: bold;
            color: #4698FF;
          }
        }
      }

      .box1Bot {
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(1, 107px);
        grid-row-gap: 20px; //行
        grid-column-gap: 10px; //列
        box-sizing: border-box;
        padding: 30px 0;

        li {
          // margin-right: 10px;
          height: 107px;
          position: relative;
          align-items: center;

          .imgBox1 {
            width: 80px;
            height: 80px;
          }

          .text {

            // margin-left: 6px;
            h3 {
              font-size: 18px;
              font-weight: bold;
              color: #312120;
              margin-bottom: 12px;
            }

            p {
              font-size: 14px;
              font-weight: 400;
              color: #312120;
            }
          }

          .tag {
            position: absolute;
            right: 0;
            top: 0;
            width: 48px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
            text-align: center;
            background: url(/static/images/new/bgf.png) no-repeat 100% 100%;
            // background-repeat: no-repeat;
            // background-size: 100% 100%;

          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        li:nth-child(4n+1) {
          background: linear-gradient(90deg, #FFFFFF 0%, #FFF4F6 100%);
        }

        li:nth-child(4n+2) {
          background: linear-gradient(90deg, #FFFFFF 0%, #FFF8E7 100%);
        }

        li:nth-child(4n+3) {
          background: linear-gradient(90deg, #FFFFFF 0%, #EDF9FF 100%);
        }

        li:nth-child(4n+4) {
          background: linear-gradient(90deg, #FFFFFF 0%, #F7F2FF 100%);
          margin: 0;
        }
      }
    }

    // //////
    .box2 {
      padding: 30px 0 24px 0;
      background-color: #F5F9FC;
      width: 100%;

      .tit {
        margin-bottom: 20px;
      }

      .content {
        flex-wrap: wrap;
        justify-content: space-between;
        // align-items:center;
        // flex: 0 0 25%;
        display: grid;
        box-sizing: border-box;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(1, 320px);
        grid-row-gap: 30px; //行
        grid-column-gap: 20px; //列
        width: 100%;

        li {
          position: relative;
          background: #FFFFFF;
          box-shadow: 0px 2px 11px 6px rgba(0, 0, 0, 0.04);
          border-radius: 8px;
          height: 320px;
          // margin-right: 20px;
          // margin-bottom: 30px;

          .tag {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
            width: 59px;
            height: 27px;
            border-radius: 8px 0px 16px 0px;
            background: rgba(0, 0, 0, 0.3);
            line-height: 27px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
          }
					
					.tag_img{
						position: absolute;
						top: 0;
						right: 0;
						z-index: 99;
					}

          .imgBox {
            width: 100%;
            height: 195px;

            // margin-bottom: 15px;
            img {
              width: 100%;
              height: 100%;
            }
          }

          .txtContent {
            padding: 15px 12px;
            box-sizing: border-box;

            .dataNum {
              width: 100%;
              justify-content: space-between;
              margin-bottom: 20px;

              span:first-child {
                font-size: 14px;
                font-weight: bold;
                color: #FF7327;

                span {
                  font-size: 12px;
                  color: #FF7327;
                  font-weight: bold;
                }
              }

              span:last-child {
                font-size: 14px;
                font-weight: 300;
                color: #B5B5B5;
              }
            }

            h3 {
              font-size: 18px;
              font-weight: bold;
              color: #312120;
              margin-bottom: 8px;
            }

            p {
              font-size: 14px;
              font-weight: 400;
              color: #9A9A9A;
              width: 255px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }


      }

    }

    // ////////////////////
    .box3 {

      .cont1 {
        padding-top: 30px;
        background-color: #FFFFFF;

        .tit {
          margin-bottom: 21px;
        }

        .content {
          height: 220px;
          background-image: url("/static/images/new/xyfwBg.png");
          padding: 34px 65px;
          box-sizing: border-box;
          // margin-bottom: 43px;
          color: #FFFFFF;
          &:extend(.bg);

          .top {
            align-items: center;

            .txt {
              font-size: 24px;
              font-weight: bold;
              color: #FFFFFF;
              margin-right: 16px;
              margin-bottom: 10px;
            }

            .rate {
              width: 197px;
              height: 52px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .bot {
            margin-top: 22px;

            li {
              margin-right: 64px;

              .num {
                font-size: 40px;
                font-weight: bold;
                margin-bottom: 10px;
              }

              .txt {
                font-size: 14px;
                font-weight: 400;
              }
            }
          }
        }
      }

      .cont2 {
        background-image: url("/static/images/new/fwpjBg.png");
        height: 578px;
        width: 100%;
        padding: 43px 0 26px 0;
        box-sizing: border-box;
        margin-bottom: 22px;
        &:extend(.bg);

        .tit {
          margin-bottom: 24px;
        }

        .content {
          height: 463px;
          background: #FFFFFF;
          box-shadow: 0px 5px 11px 5px rgba(160, 209, 220, 0.09);
          border-radius: 16px;
          border: 1px solid #F3F3F3;

          .top {
            height: 48px;
            border-bottom: 1px solid #F0F2F4;
            align-items: center;
            padding: 0 30px;
            box-sizing: border-box;

            >div {
              width: 15px;
              height: 15px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 10px;
            }

            >div:first-child {
              background-color: #FEAEAD;
            }

            >div:nth-child(2) {
              background-color: #FFDEAE;
            }

            >div:last-child {
              background-color: #AFF9DA;
            }
          }

          .con {
            padding: 30px 30px;
            box-sizing: border-box;

            li {
              align-items: center;
              margin-bottom:10px ;
              .flImg {
                width: 58px;
                height: 58px;
                border-radius: 50%;
                overflow: hidden;
                align-items: center;
                margin-right: 15px;
                margin-bottom: 6px;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .frNews {
                .news {
                  max-width: 1045px;
                  height: 56px;
                  padding: 0 18px;
                  line-height: 56px;
                  background: #F2F7F8;
                  border-radius: 100px 100px 100px 0px;
                  margin-bottom: 8px;
                  box-sizing: border-box;

                  font-size: 14px;
                  font-weight: bold;
                  color: #333333;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .info {
                  align-items: center;

                  .companyName {
                    margin-right: 8px;
                    font-size: 14px;
                    font-weight: 300;
                    color: #949191;
                  }

                  .rate {}
                }

              }
            }

            li:nth-child(2n) {
              flex-direction: row-reverse; // flex-direction属性   设置 <div> 元素内弹性盒元素的方向为相反的顺序：

              .flImg {
                margin-left: 15px;
              }

              .frNews {
                .news {
                  background: #F8A449;
                  border-radius: 100px 100px 0 100px;
                  color: #FFFFFF;

                }

                .info {
                  flex-direction: row-reverse;

                  .companyName {
                    margin-left: 8px;
                    margin-right: 0;
                  }
                }
              }

            }

          }
        }
      }

      .cont3 {
        .cont3In {
          padding-bottom: 16px;
        }

        .tit {
          margin-bottom: 46px;
        }

        .partner {
          flex-wrap: wrap;
          justify-content: space-between;

          li {
            margin-bottom: 32px;
            // flex: 0 0 20%;
            // margin-right: 21px;
            width: 220px;
            height: 79px;
            border-radius: 5px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          li:hover {
            box-shadow: 0px 10px 11px 2px rgba(100, 100, 100, 0.1);
          }

          li:nth-child(5n) {
            margin-right: 0;
          }
        }

      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/index/indexContent.vue